import { useTranslation } from "react-i18next";
import { Form } from "react-final-form";
import { Button } from "ui/shared/components/Buttons";
import { useDispatch, useSelector } from "react-redux";
import { hideSignInModal } from "data/account/actions/signInModal";

export default function EmailSent() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { email } = useSelector(state => state.account.signInModal)

    return (
        <div className={"space-y-4 flex flex-col max-w-[400px] text-justify"}>
            <h2 className="text-xl font-bold">{t('account_button.email_sent')}</h2>
            <Form
                onSubmit={(values) => {
                    return (
                        dispatch(hideSignInModal())
                    )
                }}
            >
                {({ handleSubmit }) => {
                    return (
                        <form className="lg:w-[400px]" onSubmit={handleSubmit}>
                            <div className="mb-4">
                                <p>{`${t('account_button.send_email_success_1')} ${email} !`}</p>
                                <p>{t('account_button.send_email_success_2')}</p>
                                <p>{t('account_button.see_you_soon')}</p>
                            </div>
                            <div className="flex justify-center">
                                <Button
                                    type="submit"
                                    className="p-3 rounded-md bg-gray-500 text-white hover:bg-gray-600"
                                >
                                    {t('account_button.close')}
                                </Button>
                            </div>
                        </form>
                    );
                }}
            </Form>
        </div>
    )
}